<template>
  <div>
    <text-box-title title="Friendship Park Board of Commissioners">
      <div class="col-md-6 mt-3 board-list">
        <ul class="no-dots">
          <li>Roger Hilty</li>
          <li>Judy Henthorn</li>
          <li>Fred Abdalla, Jr.</li>
        </ul>

        <div class="mt-4 text-bold">
          The Board of Commissioners holds its regular public meeting on the Third Tuesday of each month at 6:30 pm it the Park Office.
        </div>
      </div>
      
    </text-box-title>
  </div>
</template>

<script>
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'

export default {
  components: {
    TextBoxTitle
  },
  data () {
    return {}
  },
  props: [],
  mounted: function() {
    //called on launch
  },
  methods: {}
}

</script>

<style scoped>

.board-list ul > li {
  padding-top: 0.75em;
}

</style>